import React, { FunctionComponent, SVGProps } from 'react'

export const IconArrowDownSmall: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#9595a3"
      {...props}
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
